import { styled } from "goober";
import type { ReactNode } from "react";
import { zIndexes } from "../../lib/zIndexes";
import { AnchoredPopover } from "../AnchoredPopover";
import { Icon } from "../Icon";

const Bubble = styled("div")`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 8px;
  background: var(--tooltip-bg);
  color: var(--tooltip-fg);
  border-radius: 12px;
  box-shadow: var(--elevation-low);
  font-size: 10px;
  pointer-events: none;
  position: relative;

  &::before {
    content: "";
    position: absolute;
    bottom: -3px;
    left: 50%;
    width: 8px;
    height: 8px;
    background: var(--tooltip-bg);
    transform: translateX(-50%) rotate(45deg);
    clip-path: polygon(100% 0, 100% 100%, 0 100%);
  }
`;

type Props = {
  show: boolean;
  count: number;
  trigger: (props: { style: React.CSSProperties }) => ReactNode;
};

export function TabNudge({ show, count, trigger }: Props) {
  const popoverStyle: React.CSSProperties = {
    bottom: "anchor(top)",
    left: "anchor(center)",
    translate: "-50% 0",
    marginBottom: "8px",
    background: "transparent",
    boxShadow: "none",
    zIndex: zIndexes.tooltip,
  };

  return (
    <AnchoredPopover isOpen={show} trigger={trigger} style={popoverStyle}>
      <Bubble>
        {count} {count === 1 ? "match" : "matches"}
        <Icon name="corner-down-left" size={10} color="var(--text-secondary)" />
      </Bubble>
    </AnchoredPopover>
  );
}
